$('.btn--secondary').each(function() {
    $(this).html('<i class="btn__icon icon icon-arrow-right"></i>' + $(this).html());
});

$('.banner .btn').each(function() {
    if ($(this).text().indexOf('@traasvloeren.nl') >= 0) {
        $(this).prepend('<i class="btn__icon icon icon-mail me-3"></i> ');
    }
});
